/**
 * Temporary allowlist of offer IDs for which the new canUpgradePackage flag
 * from svc-order is used for self-service package upgrades.
 * This restricts the rollout to only these properties while we validate the flow.
 * For non-allowlisted offers, the pre-existing canAutoRefund / canRefundItem logic applies.
 * TODO: Remove this allowlist once canUpgradePackage is validated for all offers.
 */
export const PACKAGE_UPGRADE_ALLOWED_OFFER_IDS = new Set([
  '006RF00000ONXqHYAX', // Merusaka Nusa Dua
  '006RF00000OqAVJYA3', // Katathani Phuket
])
